function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import Decimal from 'decimal.js';
import { FormProvider, useForm } from 'react-hook-form';
import { Tooltip, Typography } from 'seagull';
import { serviceToInput } from "../../../../components/ServiceBuilder/ServiceBuilder.utils";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { serviceCostModel, serviceModel } from "../../../../models";
import { isOneTimeInStages } from "../../../../models/service-billing";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getPriceData } from "./service.utils";
import { renderDecimalDiscountTitle, renderRangeDiscountTitle } from "./serviceDiscountTitles";
import { ServiceRateModalContent } from "./ServiceRateModalContent/ServiceRateModalContent";
import { ServiceRateModalContentOld } from "./ServiceRateModalContent/ServiceRateModalContentOld";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ServiceRateCell(_ref) {
  let {
    index,
    service,
    isDisabled,
    disabledTooltip,
    onOpenModal
  } = _ref;
  const defaultValues = useMemo(() => serviceToInput({
    service,
    qboItems: [],
    xeroItems: []
  }), [service]);
  const form = useForm({
    mode: 'all',
    defaultValues
  });
  const {
    SERVICE_TEMPLATE_BUNDLE,
    START_BILLING_AT_PHASE_2_INLINE
  } = useFeatureFlags();
  const isBundle = Boolean(SERVICE_TEMPLATE_BUNDLE && serviceModel.isBundle(service));
  const onClick = () => {
    form.reset(defaultValues);
    onOpenModal({
      width: '450px',
      renderContent: _ref2 => {
        let {
          draft,
          setDraft
        } = _ref2;
        return {
          title: "".concat(isBundle ? 'Bundle' : 'Service', " rate"),
          testId: "edit-service-rate-modal-".concat(index),
          content: START_BILLING_AT_PHASE_2_INLINE ? /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
            children: /*#__PURE__*/_jsx(ServiceRateModalContent, {
              service: service,
              draft: draft,
              setDraft: setDraft
            })
          })) : /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
            children: /*#__PURE__*/_jsx(ServiceRateModalContentOld, {
              service: service,
              draft: draft,
              setDraft: setDraft
            })
          })),
          onSubmit: defaultBehavior => {
            form.handleSubmit(defaultBehavior)();
          }
        };
      }
    });
  };
  const {
    price,
    discountedPrice,
    hasDiscount
  } = getPriceData(service.cost);
  const isVariable = serviceCostModel.isVariablePrice(service.cost);
  const unitName = serviceCostModel.formattedUnitNameShort(service.cost);
  const error = isOneTimeInStages(service.billing) && service.cost.discount && !service.cost.discount.isPercent();
  const title = discountedPrice == null ? '' : discountedPrice instanceof Decimal ? renderDecimalDiscountTitle(discountedPrice, price, hasDiscount, isVariable, unitName, "service-rate-before-discount-".concat(index)) : renderRangeDiscountTitle(discountedPrice, price, hasDiscount, "service-rate-before-discount-".concat(index));
  const tooltipTitle = error ? 'When the billing trigger is set to ‘In stages’, the discount can only be applied as a percentage' : title;
  const discountSubheader = service.cost.discount && service.cost.discount.amount().gt(0) && service.cost.discount.format();
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testId: "edit-service-rate-cell-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: tooltipTitle,
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography, {
          skin: error ? 'error' : 'standard',
          "aria-invalid": !!error,
          testId: "service-rate-".concat(index),
          ellipsis: true,
          hideTooltip: true,
          children: title
        }), discountSubheader && /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: error ? 'error' : 'secondary',
          testId: "service-rate-".concat(index, "-discount-subheader"),
          children: "".concat(discountSubheader, " discount")
        })]
      })
    })
  });
}